<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    required: true
  }
})
const emit = defineEmits(['update:modelValue'])

function selectUnits(units) {
  emit('update:modelValue', units);
}
</script>

<template>
  <div class="UnitsSelector">
    <button 
      class="UnitsButton"
      :class="{ active: modelValue === 'Imperial' }"
      @click="selectUnits('Imperial')"
    >
      <div class="UnitsLabel">Imperial</div>
      <div class="UnitsSubtext">°F, ft, lb</div>
    </button>
    <button 
      class="UnitsButton"
      :class="{ active: modelValue === 'Metric' }"
      @click="selectUnits('Metric')"
    >
      <div class="UnitsLabel">Metric</div>
      <div class="UnitsSubtext">°C, m, kg</div>
    </button>
  </div>
</template>

<style scoped>
.UnitsSelector {
  display: flex;
  border: 1px solid var(--b-20);
  border-radius: var(--br-s);
  overflow: hidden;
  width: fit-content;
}

.UnitsButton {
  padding: var(--space-xs) var(--space-s);
  border: none;
  background-color: var(--white);
  color: var(--grey-40);
  font-size: var(--f-s);
  font-weight: 500;
  cursor: pointer;
  border-radius: 0;
  min-width: 120px;
  text-align: center;
}

.UnitsButton:hover {
  background-color: var(--grey-95);
  color: var(--grey-20);
}

.UnitsButton.active {
  background-color: var(--pc);
  color: white;
  font-weight: 600;
}

.UnitsButton.active:hover {
  background-color: var(--pc-dark);
}

.UnitsLabel {
  font-weight: inherit;
  margin-bottom: 2px;
}

.UnitsSubtext {
  font-size: var(--f-xs);
  opacity: 0.8;
  font-weight: 400;
}

.UnitsButton:not(:last-child) {
  border-right: 1px solid var(--b-20);
}
</style>
